export function hasLeagueId(item) {
    return (item === null || item === void 0 ? void 0 : item.leagueId) !== undefined;
}
//# sourceMappingURL=hasLeagueId.js.map